import { render, staticRenderFns } from "./ResearchMultiSectionsSearch.vue?vue&type=template&id=7520d13c"
import script from "./ResearchMultiSectionsSearch.vue?vue&type=script&lang=js"
export * from "./ResearchMultiSectionsSearch.vue?vue&type=script&lang=js"
import style0 from "./ResearchMultiSectionsSearch.vue?vue&type=style&index=0&id=7520d13c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7520d13c')) {
      api.createRecord('7520d13c', component.options)
    } else {
      api.reload('7520d13c', component.options)
    }
    module.hot.accept("./ResearchMultiSectionsSearch.vue?vue&type=template&id=7520d13c", function () {
      api.rerender('7520d13c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchMultiSectionsSearch.vue"
export default component.exports